function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import OnOffIcon from 'svg/on-off.svg';
import accessTokenShape from 'shapes/accessTokenShape';
import Account from 'modules/Account';
import Visit from 'modules/Visit';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
var _React_PureComponent;
class StartStopVisitBtn extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { activeVisit, activeClinicMembership } = this.props;
        if (prevProps.activeVisit !== activeVisit && activeVisit && !activeVisit.metadata) {
            this.props.onFetchVisitMetadata(activeVisit, activeClinicMembership);
        }
    }
    onAction(activeVisit) {
        const { activeClinicMembership, activePatient, phiSet, phiSetDocumentId, sharingRequest } = this.props;
        if (activeVisit) {
            this.props.onEndVisit(activePatient, phiSet, activeClinicMembership, activeVisit, sharingRequest);
            return;
        }
        this.props.onStartVisit(activePatient, phiSet, phiSetDocumentId, activeClinicMembership);
    }
    get isDisabled() {
        return !this.props.activePatient || !this.props.phiSet || !this.props.phiSetDocumentId;
    }
    render() {
        const { activeVisit, isInProgress } = this.props;
        return /*#__PURE__*/ _jsxs(Button, {
            styleModifier: activeVisit ? 'secondary' : 'primary',
            className: "btn--filled ml-4",
            isDisabled: this.isDisabled,
            isInProgress: isInProgress,
            /*
        Delay onAction to ensure onBlur (notes save) runs first.
        Without this, click might fire before blur completes, breaking Redux/saga order.
        */ onClick: ()=>{
                setTimeout(()=>this.onAction(activeVisit), 0);
            },
            children: [
                /*#__PURE__*/ _jsx(OnOffIcon, {
                    className: "btn__icon mr-3"
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons[activeVisit ? 'endVisit' : 'startVisit']))
            ]
        });
    }
}
_define_property(StartStopVisitBtn, "propTypes", {
    // Explicit props
    activePatient: PropTypes.shape({
        storageProvider: PropTypes.string,
        accessToken: accessTokenShape
    }),
    phiSet: PropTypes.object,
    phiSetDocumentId: PropTypes.string,
    // Implicit props
    activeVisit: Visit.shapes.visit,
    activeClinicMembership: Account.shapes.clinicMembership,
    sharingRequest: shapes.sharingRequest,
    isInProgress: PropTypes.bool,
    // Implicit actions
    onStartVisit: PropTypes.func.isRequired,
    onEndVisit: PropTypes.func.isRequired,
    onFetchVisitMetadata: PropTypes.func.isRequired
});
const mapStateToProps = (state)=>({
        sharingRequest: selectors.sharingRequest(state),
        isInProgress: selectors.isStartPatientVisitInProgress(state) || selectors.isEndPatientVisitInProgress(state),
        // || CloudDrive.selectors.isSendNotesInProgress(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        activeVisit: Visit.selectors.activeVisit(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onStartVisit: (clinicPatient, phiSet, phiSetDocumentId, clinicMembership)=>dispatch(actions.startPatientVisit(clinicPatient, phiSet, phiSetDocumentId, clinicMembership)),
        onEndVisit: (clinicPatient, phiSet, clinicMembership, visit, sharingRequest)=>dispatch(actions.endPatientVisit(clinicPatient, phiSet, clinicMembership, visit, sharingRequest)),
        onFetchVisitMetadata: (activeVisit, clinicMembership)=>dispatch(Visit.actions.fetchVisitMetadata(activeVisit, clinicMembership))
    });
const ConnectedStartStopVisitBtn = connect(mapStateToProps, mapDispatchToProps)(StartStopVisitBtn);
export default ConnectedStartStopVisitBtn;
